import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
console.log("Starting script");

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log("index.js: Working 1")
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);